'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.App = undefined;

var _bluebird = require('bluebird');

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactScrolla = require('react-scrolla');

var _reactScrolla2 = _interopRequireDefault(_reactScrolla);

var _LogProvider = require('./Providers/LogProvider.js');

var _LogTable = require('./Components/LogTable.js');

var _ToggleEntry = require('./Components/ToggleEntry.js');

var _LogUploader = require('./Components/LogUploader.js');

var _ocReactComponents = require('oc-react-components');

var _Search = require('./Search.js');

var _LogFile = require('./Providers/LogFile.js');

var _app = require('../css/app.css');

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = exports.App = function (_Component) {
	_inherits(App, _Component);

	function App() {
		var _this2 = this;

		_classCallCheck(this, App);

		var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));

		_this.state = {
			entries: [],
			loading: true,
			levels: [false, false, false, false, false],
			provider: null,
			relative: true,
			dateFormat: 'Y-m-d\TH:i:sO',
			live: false
		};
		_this.fetchNextPage = _.throttle((0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee() {
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							if (!_this.state.provider.hasMore) {
								_context.next = 6;
								break;
							}

							_this.setState({ loading: true });
							_this.state.provider.limit += 25;
							_context.next = 5;
							return _this.state.provider.load();

						case 5:
							_this.setState({ loading: false });

						case 6:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this2);
		})), 100);

		_this.onLogFile = function () {
			var _ref2 = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee2(content) {
				var logFile;
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								logFile = new _LogFile.LogFile(content);

								logFile.on('entries', function (entries) {
									if (_this.state.provider === logFile) {
										_this.setState({ entries: entries });
									}
								});
								_context2.prev = 2;
								_context2.next = 5;
								return logFile.loadEntries(0);

							case 5:
								_this.setState({ provider: logFile, entries: [] });
								logFile.load();
								_context2.next = 12;
								break;

							case 9:
								_context2.prev = 9;
								_context2.t0 = _context2['catch'](2);

								OC.Notification.show(t('logreader', 'Error parsing log'));

							case 12:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[2, 9]]);
			}));

			return function (_x) {
				return _ref2.apply(this, arguments);
			};
		}();

		_this.setRelative = function (relative) {
			_this.setState({ relative: relative });
			_this.saveRelative(relative);
		};

		_this.setLive = function (live) {
			_this.setState({ live: live });
			if (live) {
				_this.logProvider.startPolling();
			} else {
				_this.logProvider.stopPolling();
			}
			_this.saveLive(live);
		};

		_this.handlePaste = function (event) {
			var data = event.clipboardData.getData('Text');
			if (!data) {
				data = event.clipboardData.getData('text/plain');
			}
			data = data.trim();
			if (data.indexOf('{') !== -1 && data.indexOf('}')) {
				_this.onLogFile(data);
			}
		};

		_this.logProvider = new _LogProvider.LogProvider(50);
		_this.logProvider.on('entries', function (entries) {
			if (_this.state.provider === _this.logProvider) {
				_this.setState({ entries: entries });
			}
		});
		OCA.Search.logreader = new _Search.LogSearch(_this.logProvider);
		_this.saveLevels = _.debounce(_this.logProvider.setLevels, 100);
		_this.saveRelative = _.debounce(_this.logProvider.setRelative, 100);
		_this.saveLive = _.debounce(_this.logProvider.setLive, 100);
		return _this;
	}

	_createClass(App, [{
		key: 'componentDidMount',
		value: function () {
			var _ref3 = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee3() {
				var levels, relative, dateFormat, live;
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return this.logProvider.getLevels();

							case 2:
								levels = _context3.sent;
								_context3.next = 5;
								return this.logProvider.getRelative();

							case 5:
								relative = _context3.sent;
								_context3.next = 8;
								return this.logProvider.getDateFormat();

							case 8:
								dateFormat = _context3.sent;
								_context3.next = 11;
								return this.logProvider.getLive();

							case 11:
								live = _context3.sent;

								this.setState({
									levels: levels,
									relative: relative,
									dateFormat: dateFormat,
									live: live,
									provider: this.logProvider
								});
								_context3.next = 15;
								return this.logProvider.load();

							case 15:
								if (live) {
									this.logProvider.startPolling();
								}
								this.setState({ loading: false });
								document.addEventListener('paste', this.handlePaste);

							case 18:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function componentDidMount() {
				return _ref3.apply(this, arguments);
			}

			return componentDidMount;
		}()
	}, {
		key: 'setLevel',
		value: function setLevel(level, newState) {
			var _this3 = this;

			var levels = this.state.levels;
			levels[level] = newState;
			var entries = this.state.entries.filter(function (entry) {
				return _this3.state.levels[entry.level];
			});
			if (entries.length < 50) {
				this.fetchNextPage();
			}
			this.setState({ levels: levels });
			this.saveLevels(levels);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var entries = this.state.entries.filter(function (entry) {
				if (!entry.level && entry.level !== 0) {
					return true;
				}
				return _this4.state.levels[entry.level];
			});

			var filters = this.state.levels.map(function (status, level) {
				return _react2.default.createElement(
					_ToggleEntry.ToggleEntry,
					{ key: level, active: status,
						onChange: _this4.setLevel.bind(_this4, level) },
					_LogProvider.LogProvider.levels[level]
				);
			});

			var content = void 0;

			if (this.state.loading && entries.length < 1) {
				content = _react2.default.createElement('div', { className: 'loading log-loading' });
			} else {
				content = _react2.default.createElement(
					_reactScrolla2.default,
					{
						className: _app2.default.scrollContainer,
						percentage: 85,
						onPercentage: this.fetchNextPage,
						isLoading: this.state.loading },
					_react2.default.createElement(
						'div',
						{ className: _app2.default.content },
						_react2.default.createElement(_LogTable.LogTable, {
							inlineSettings: this.props.inlineSettings,
							levels: this.state.levels,
							setRelative: this.setRelative,
							setLevel: this.setLevel.bind(this),
							entries: entries,
							relative: this.state.relative,
							dateFormat: this.state.dateFormat,
							hidden: this.state.entries.length - entries.length,
							live: this.state.live,
							setLive: this.setLive.bind(this)
						})
					)
				);
			}

			return _react2.default.createElement(
				'div',
				null,
				!this.props.inlineSettings ? _react2.default.createElement(
					_ocReactComponents.SideBar,
					null,
					_react2.default.createElement(_LogUploader.LogUploader, {
						onLogFile: this.onLogFile }),
					_react2.default.createElement(_ocReactComponents.Separator, null),
					filters,
					_react2.default.createElement(
						_ocReactComponents.Settings,
						null,
						_react2.default.createElement(
							_ToggleEntry.ToggleEntry,
							{ key: 'relative',
								active: this.state.relative,
								onChange: this.setRelative },
							'Relative Dates'
						)
					)
				) : _react2.default.createElement('div', null),
				content
			);
		}
	}]);

	return App;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./js/App.js
// module id = 649
// module chunks = 0